"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var userAwarenessChannelConstants;

(function (userAwarenessChannelConstants) {
  userAwarenessChannelConstants["BOUGHT_GIFT"] = "BOUGHT_GIFT";
  userAwarenessChannelConstants["FRIEND_FAMILY"] = "FRIEND_FAMILY";
  userAwarenessChannelConstants["TV_COMMERCIAL"] = "TV_COMMERCIAL";
  userAwarenessChannelConstants["PODCAST"] = "PODCAST";
  userAwarenessChannelConstants["GOOGLE_SEARCH"] = "GOOGLE_SEARCH";
  userAwarenessChannelConstants["WEDDING_BLOG"] = "WEDDING_BLOG";
  userAwarenessChannelConstants["FACEBOOK"] = "FACEBOOK";
  userAwarenessChannelConstants["INSTAGRAM"] = "INSTAGRAM";
  userAwarenessChannelConstants["PINTEREST"] = "PINTEREST";
  userAwarenessChannelConstants["SUBWAY"] = "SUBWAY";
  userAwarenessChannelConstants["PUBLICATION"] = "PUBLICATION";
  userAwarenessChannelConstants["TIKTOK"] = "TIKTOK";
  userAwarenessChannelConstants["OTHER"] = "OTHER";
})(userAwarenessChannelConstants || (userAwarenessChannelConstants = {}));

var _default = userAwarenessChannelConstants;
exports.default = _default;